import { ChapterModel } from '../../models/chapter.model';
import { StoryChapterThumbnail } from '../../models/story-chapter-thumbnail.model';

export class StoryChaptersStateModel {
    loading: boolean;
    chapters: ChapterModel[];
    selectedChapter: string;
    shadowChapter: ChapterModel;
    thumbnails: Map<string, StoryChapterThumbnail>;
}
